{
  "en": {
    "new-version": "The site has been updated.",
    "new-version-bis": "Please click on refresh to get the new version.",
    "refresh-button": "Refresh"
  },
  "fr": {
    "new-version": "Le site à été mis à jour.",
    "new-version-bis": "Cliquez sur le bouton 'Rafraichir' pour obtenir la nouvelle version.",
    "refresh-button": "Rafraichir"
  }
}